export const LOADING_DELIVERY = "LOADING_DELIVERY";
export const GET_DELIVERY_LIST = "GET_DELIVERY_LIST";
export const REMOVE_DELIVERY = "REMOVE_DELIVERY";
export const ADD_DELIVERY = "ADD_DELIVERY";
export const UPDATE_DELIVERY = "UPDATE_DELIVERY";
export const GET_DELIVERYBYID = "GET_DELIVERYBYID";
export const UPDATE_DELIVERY_STATUS = "UPDATE_DELIVERY_STATUS";
export const ADD_DELIVERY_ITEM = "ADD_DELIVERY_ITEM";
export const GET_DELIVERY_ITEM_LIST = "GET_DELIVERY_ITEM_LIST";
export const GET_DELIVERY_ITEM_BYID = "GET_DELIVERY_ITEM_BYID";
export const UPDATE_DELIVERY_ITEM = "UPDATE_DELIVERY_ITEM";
export const REMOVE_DELIVERY_ITEM = "REMOVE_DELIVERY_ITEM";
export const UPDATE_DELIVERY_ITEM_STATUS = "UPDATE_DELIVERY_ITEM_STATUS";
export const GET_DELIVERYBYID_SIGNATURE = "GET_DELIVERYBYID_SIGNATURE";
export const ADD_DELIVERY_SIGNATURE = "ADD_DELIVERY_SIGNATURE";